import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import {
  BrowseFilter,
  FilterNamesEnum,
  getAllFiltersInSearchMode,
} from '../../models/filter';
import { Store } from '../../../../shared/store';
import { FilterState } from './filter.state';

const filterState = new FilterState();

@Injectable({ providedIn: 'root' })
export class FilterStore extends Store<FilterState> {
  videoFilters$ = this.state$.pipe(map((s) => s.videoFilters));
  playlistFilters$ = this.state$.pipe(map((s) => s.playlistFilters));
  gpsFilters$ = this.state$.pipe(map((s) => s.gpsFilters));
  workoutFilters$ = this.state$.pipe(map((s) => s.workoutFilters));
  coachingFilters$ = this.state$.pipe(map((s) => s.coachingFilters));
  searchedContentFilters$ = this.state$.pipe(
    map((s) => s.searchedContentFilters)
  );
  mapFilters$ = this.state$.pipe(map((s) => s.mapFilters));

  constructor() {
    super(filterState);
  }

  setVideoFilters(nextVideoFilters: BrowseFilter[]): void {
    this.setState({ ...this.state, videoFilters: nextVideoFilters });
  }

  setPlaylistFilters(nextPlaylistFilters: BrowseFilter[]): void {
    this.setState({ ...this.state, playlistFilters: nextPlaylistFilters });
  }

  setGpsFilters(nextGpsFilters: BrowseFilter[]): void {
    this.setState({ ...this.state, gpsFilters: nextGpsFilters });
  }

  setWorkoutFilters(nextWorkoutFilters: BrowseFilter[]): void {
    this.setState({ ...this.state, workoutFilters: nextWorkoutFilters });
  }

  setCoachingFilters(nextCoachingFilters: BrowseFilter[]): void {
    this.setState({ ...this.state, coachingFilters: nextCoachingFilters });
  }

  setSearchedContentFilters(nextSearchedContentFilters: BrowseFilter[]): void {
    const previousModeFilter: BrowseFilter =
      this.state.searchedContentFilters.find(
        (f) => f.name === FilterNamesEnum.SearchMode
      );
    const nextModeFilter: BrowseFilter = nextSearchedContentFilters.find(
      (f) => f.name === FilterNamesEnum.SearchMode
    );

    if (
      previousModeFilter.selectedOptions[0].value ===
      nextModeFilter.selectedOptions[0].value
    ) {
      this.setState({
        ...this.state,
        searchedContentFilters: nextSearchedContentFilters,
      });
      return;
    }

    const newSearchedContentFilters: BrowseFilter[] =
      getAllFiltersInSearchMode(nextModeFilter);

    this.setState({
      ...this.state,
      searchedContentFilters: newSearchedContentFilters,
    });
  }

  setMapFilters(nextMapFilters: BrowseFilter[]): void {
    this.setState({ ...this.state, mapFilters: nextMapFilters });
  }

  resetWorkoutTypeSelectedOptions(): void {
    const newWorkoutFilters: BrowseFilter[] = JSON.parse(
      JSON.stringify(this.state.workoutFilters)
    );
    const newWorkoutTypeFilter: BrowseFilter = newWorkoutFilters.find(
      (filter) => {
        return filter.name === FilterNamesEnum.WorkoutType;
      }
    );
    newWorkoutTypeFilter.selectedOptions = [];
    this.setWorkoutFilters(newWorkoutFilters);
  }
}
